module.exports = __webpack_public_path__ + "static/media/mic_on.2477d28d.svg";